import theme from 'styles/theme';
import { Close } from '@styled-icons/remix-fill';

import scInfoSvg from 'v3/assets/svg/sc-info-icon.svg';
import * as S from './styles';

export type ModalNotificationProps = {
  title: string;
  content: string;
  buttonText: string;
  open: boolean;
  onCancel: () => void;
  onClick: () => void;
};

const ModalNotification = ({
  title,
  content,
  buttonText,
  open,
  onCancel,
  onClick,
}: ModalNotificationProps) => (
  <S.Modal
    centered
    footer={null}
    onCancel={onCancel}
    open={open}
    width={552}
    closeIcon={<Close size={24} color={theme.colors.neutralSilver50} />}
  >
    <S.TitleContainer>
      <img src={scInfoSvg} alt="" />
      <S.Title>{title}</S.Title>
    </S.TitleContainer>
    <S.Content>{content}</S.Content>
    <S.Button onClick={onClick}>{buttonText}</S.Button>
  </S.Modal>
);

export default ModalNotification;
